import type { RouteObject } from "react-router-dom";
import { Configuration } from "./Configuration";
import { ConfigurationNotFound } from "./components/ConfigurationNotFound";
import { MyInfo } from "./MyInfo/MyInfo";

// `Configuration` gates the whole subtree on the `ddc-configuration-access` LD flag.
export const PagesConfigurationUiRoutes: RouteObject[] = [
  {
    path: "configuration",
    element: <Configuration />,
    children: [
      {
        index: true,
        element: <MyInfo />
      },
      {
        path: "myinfo",
        element: <MyInfo />
      },
      /*
       * FR-010: an unrecognized location beneath Configuration resolves to a graceful not-found,
       * never a blank page.
       *
       * A **message**, not a redirect. React-router v7 resolves relative paths against the leaf
       * match's full pathname *including the splat*, so a relative `<Navigate to="myinfo" />` in here
       * loops forever, growing the URL on each hop — and neither ESLint nor CI catches it (research
       * R-010). Rendering a message avoids the class of bug outright. If a redirect is ever preferred,
       * it MUST use `SplatRedirect` from `@dealer-center/core-custom-components`.
       *
       * `ConfigurationNotFound` is a component rather than being inlined here — see its own comment;
       * these route objects are built at module scope, before labels are loaded.
       */
      {
        path: "*",
        element: <ConfigurationNotFound />
      }
    ]
  }
];
